import Vue from 'vue'

import {
    Pagination,
    Button,
    Input,
    Table,
    TableColumn,
    DatePicker,
    Switch,
    Radio,
    RadioGroup,
    Checkbox,
    Select,
    Option,
    Form,
    FormItem,
    Loading,
    MessageBox,
    Message,
    Notification,
    Upload,
    Dialog,
} from 'element-ui'

Vue.use(Button, { size: 'small' })
Vue.use(Table)
Vue.use(Pagination)
Vue.use(TableColumn)
Vue.use(DatePicker)
Vue.use(Switch)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Upload)
Vue.use(Dialog)

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
